import React, { useState } from "react";
import OrderSummary from "./OrderSummary";
import OrderTable from "./OrderTable";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import SearchInput from "../../../components/form/SearchInput";
import FilterByButton from "../../ui/FilterButton";
import { dispatchStatusFilter, orderStatusFilter } from "./util";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { RootState } from "../../../redux/app/store";
import {
  clearOrders,
  setCurrentTable,
} from "../../../redux/features/orderSlice";
import Button from "../../ui/Button";
import DateRangeSelector, { DateRangeType } from "../../ui/DateRangeSelector";

const OrderManagement = () => {
  const [search, setSearch] = useState<string>("");
  const [inputValue, setInputValue] = useState("");
  const [filter, setFilter] = useState<string>("");
  const [filterByDispatch, setFilterByDispatch] = useState<string>("");
  const { currentTable, orders } = useAppSelector(
    (state: RootState) => state.orders
  );
  const [selectedRange, setSelectedRange] = useState<DateRangeType>({
    startDate: null,
    endDate: null,
  });
  const { user } = useAppSelector((state) => state.auth);

  const handleDateChange = (range: DateRangeType) => {
    setSelectedRange(range);
  };

  const dispatch = useAppDispatch();

  const tabList = [
    { id: 1, name: "All Orders", count: orders?.data?.totalItems ?? 0 },
  ];

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setSearch(inputValue);
    }
  };

  return (
    <div className=" flex flex-col gap-4 sm:gap-4 p-4  sm:p-6 md:p-8 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold mb-2">Order Management</h1>
      </div>
      <OrderSummary />
      <WhiteTitledCard>
        <div className="px-6">
          <div className="flex md:items-center justify-between flex-col lg:flex-row mb-4 gap-6">
            {(user?.user?.roles === "COURIER_ADMIN" ||
              user?.user?.roles === "SUPER_ADMIN") && (
              <DateRangeSelector
                initialRange={selectedRange}
                onChange={handleDateChange}
              />
            )}
            <div className="flex-col md:flex-row md:items-center gap-4 flex">
              {(user?.user?.roles === "COURIER_ADMIN" ||
                user?.user?.roles === "SUPER_ADMIN") && (
                <div className="flex gap-2">
                  <FilterByButton
                    options={orderStatusFilter}
                    onSelect={(value) => {
                      setFilter(value);
                      dispatch(clearOrders());
                    }}
                    buttonLabel="Order status"
                  />
                  <FilterByButton
                    options={dispatchStatusFilter}
                    onSelect={(value) => {
                      setFilterByDispatch(value);
                      dispatch(clearOrders());
                    }}
                    buttonLabel="Dispatch status"
                  />
                </div>
              )}

              <SearchInput
                placeholder="Search"
                onChange={(e: any) => setInputValue(e.target.value)}
                value={inputValue}
                onKeyDown={handleKeyDown}
              />
              <Button
                customStyle={{
                  width: "auto",
                  height: "40px",
                }}
                label="filter"
                onClick={() => setSearch(inputValue)}
                classNames="hidden sm:flex"
              />
            </div>
          </div>
          <div className="flex space-x-4 items-center">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className={`space-x-2 cursor-pointer text-sm font-semibold p-2 ${
                  currentTable === tab.id
                    ? "text-black border-b-2 border-primary"
                    : ""
                }`}
                onClick={() => {
                  dispatch(setCurrentTable(tab.id));
                  setSearch("");
                  setFilter("");
                  setSelectedRange({
                    startDate: null,
                    endDate: null,
                  });
                }}
              >
                <span>{tab.name}</span>
                {
                  <span
                    className={"bg-lightPurple px-2  text-accent rounded-md"}
                  >
                    {tab?.count}
                  </span>
                }
              </div>
            ))}
          </div>
        </div>
        <OrderTable
          status={filter}
          search={search}
          filterByDispatch={filterByDispatch}
          startDate={selectedRange?.startDate}
          endDate={selectedRange?.endDate}
        />
      </WhiteTitledCard>
    </div>
  );
};

export default OrderManagement;
